import { useEffect, useState } from 'react'

/**
 * Routage par ancre (#/betting/tests/…).
 *
 * L'application est servie en statique par NestJS : une ancre évite toute
 * configuration serveur, et chaque écran garde une adresse que l'on peut
 * mettre en favori ou transmettre à un collègue.
 */

export function currentPath(): string[] {
  const raw = window.location.hash.replace(/^#\/?/, '').split('?')[0]
  return raw.split('/').filter(Boolean).map(decodeURIComponent)
}

export function navigate(path: string) {
  const target = path.startsWith('#') ? path : `#/${path.replace(/^\//, '')}`
  if (window.location.hash !== target) window.location.hash = target
}

export function useRoute(): string[] {
  const [path, setPath] = useState<string[]>(currentPath)
  useEffect(() => {
    const onChange = () => {
      const next = currentPath()
      setPath((prev) => {
        // Un nouvel écran commence en haut de page ; un simple changement de
        // filtre (partie après « ? ») garde la position de lecture.
        if (prev.join('/') !== next.join('/')) window.scrollTo({ top: 0 })
        return next
      })
    }
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])
  return path
}

/** Paramètres placés après « ? » dans l'ancre (filtres d'une liste). */
export function currentQuery(): URLSearchParams {
  const hash = window.location.hash
  const i = hash.indexOf('?')
  return new URLSearchParams(i >= 0 ? hash.slice(i + 1) : '')
}

/** Construit une ancre avec ses filtres, en omettant les valeurs vides. */
export function withQuery(path: string, params: Record<string, string | number | undefined | null>): string {
  const q = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') q.set(k, String(v))
  const s = q.toString()
  return s ? `${path}?${s}` : path
}
